module.exports = __webpack_public_path__ + "static/media/thongbao.2d880bf2.png";